module.exports = __webpack_public_path__ + "arrows.jpg?d65ff9e8d3d8046f24477d6fb4d67e72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrows.jpg
// module id = 50
// module chunks = 0